import AdminBanner from 'components/Admin/Banner/List/AdminBanner';

const AdminBannerPageList = () => {
	return <AdminBanner />;
};

export default AdminBannerPageList;
